import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";
import "../styles/Formularios.css";
import "../styles/ReportesPorCategoria.css";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import InputInventario from "./InputInventario";
import InputSelectEstados from "./InputSelectEstados";
import InputBienesAutocomplete from "./InputBienesAutocomplete";
import InputUsuarioAutocomplete from "./InputUsuarioAutocomplete";
import InputSelectIp from "./InputSelectIp";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function ReporteUsuarios({ setVista }) {

    const { logout } = useGlobal();
    const apiFetch = useApiFetch();
    const [vistaLocal, setVistaLocal] = useState("opcionesUsuarios");

    const [filtroPrincipal, setFiltroPrincipal] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [resultados, setResultados] = useState([]);

    const [idUsuario, setIdUsuario] = useState(null);
    const [usuario, setUsuario] = useState(null);
    const [aPaterno, setApaterno] = useState(null);
    const [aMaterno, setAmaterno] = useState(null);
    const [correo, setCorreo] = useState(null);
    const [idCargo, setIdCargo] = useState(null);
    const [idDireccion, setIdDireccion] = useState(null);
    const [idSede, setIdSede] = useState(null);
    const [idEdificio, setIdEdificio] = useState(null);
    const [idNivel, setIdNivel] = useState(null);
    const [idEstado, setIdEstado] = useState(null);

    const [resetEntradaUsuario, setResetEntradaUsuario] = useState(false);

    // Estados iniciales de los checkboxes de filtros
    const filtrosIniciales = {
        opcIdUsuario: false,
        opcUsuario: false,
        opcApaterno: false,
        opcAmaterno: false,
        opcCorreo: false,
        opcIdCargo: false,
        opcIdDireccion: false,
        opcIdSede: false,
        opcIdEdificio: false,
        opcIdNivel: false,
        opcIdEstado: false,
        opcTodos: false
    };

    const [filtros, setFiltros] = useState(filtrosIniciales);

    const etiquetas = {
        opcIdUsuario: "No. empleado",
        opcUsuario: "Nombre(s)",
        opcApaterno: "Apellido Paterno",
        opcAmaterno: "Apellido Materno",
        opcCorreo: "Correo",
        opcIdCargo: "Cargo",
        opcIdDireccion: "Dirección Admin.",
        opcIdSede: "Sede",
        opcIdEdificio: "Edificio",
        opcIdNivel: "Nivel",
        opcIdEstado: "Estado",
        opcTodos: "Todos los usuarios"
    };

    // Reglas de habilitación/deshabilitación por cada opcion elegida, para que las consultas tengan sentido 
    const reglas = {
        opcIdUsuario: {
            deshabilita: [
                "opcUsuario", "opcApaterno", "opcAmaterno", "opcCorreo", "opcIdCargo", "opcIdDireccion", "opcIdSede", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcUsuario: {
            deshabilita: [
                "opcIdUsuario", "opcApaterno", "opcAmaterno", "opcCorreo", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcApaterno: {
            deshabilita: [
                "opcIdUsuario", "opcUsuario", "opcAmaterno", "opcCorreo", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcAmaterno: {
            deshabilita: [
                "opcIdUsuario", "opcUsuario", "opcApaterno", "opcCorreo", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcCorreo: {
            deshabilita: [
                "opcIdUsuario", "opcUsuario", "opcApaterno", "opcAmaterno", "opcIdCargo", "opcIdDireccion", "opcIdSede", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcIdCargo: {
            deshabilita: [
                "opcIdUsuario", "opcUsuario", "opcApaterno", "opcAmaterno", "opcCorreo", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcIdDireccion: {
            deshabilita: [
                "opcIdUsuario", "opcUsuario", "opcApaterno", "opcAmaterno", "opcCorreo", "opcIdEdificio", "opcIdNivel", "opcIdEstado", "opcTodos"]
        },
        opcIdSede: {
            deshabilita: [
                "opcIdUsuario", "opcCorreo", "opcTodos"]
        },
        opcIdEdificio: {
            deshabilita: [
                "opcIdUsuario", "opcCorreo", "opcTodos"]
        },
        opcIdNivel: {
            deshabilita: [
                "opcIdUsuario", "opcCorreo", "opcTodos"]
        },
        opcIdEstado: {
            deshabilita: [
                "opcIdUsuario", "opcCorreo", "opcTodos"]
        },
        opcTodos: {
            deshabilita: [
                "opcIdUsuario", "opcUsuario", "opcApaterno", "opcAmaterno", "opcCorreo", "opcIdCargo", "opcIdDireccion", "opcIdSede", "opcIdEdificio", "opcIdNivel", "opcIdEstado"]
        }
    };

    // Función para visualizar o no las opciones de filtrado segun el campo principal elegido ////////////ok
    const handleChange = (campo) => {
        const nuevaConfig = { ...filtros };

        if (filtros[campo]) {
            // Si se desmarca un campo
            nuevaConfig[campo] = false;

            // Si era el filtro principal, se quita y se reestablece todo
            if (filtroPrincipal === campo) {
                setFiltroPrincipal(null);
                // Reinicia todos los filtros a su estado inicial
                Object.keys(nuevaConfig).forEach(opc => {
                    nuevaConfig[opc] = false;
                });
            }

        } else {
            // Si se activa el campo
            nuevaConfig[campo] = true;

            // Si aún no hay filtro principal, este se convierte en el principal
            if (!filtroPrincipal) {
                setFiltroPrincipal(campo);

                // Se aplican reglas de deshabilitación SOLO del principal
                if (reglas[campo]?.deshabilita) {
                    reglas[campo].deshabilita.forEach(opc => {
                        nuevaConfig[opc] = false;
                    });
                }
            }
            // Si ya existe un filtro principal, no se cambian las reglas
        }

        setFiltros(nuevaConfig);
    };

    // Funcion para limpiar los mensajes 
    useEffect(() => {
        if (success || error) {
            const timer = setTimeout(() => {
                setSuccess("");
                setError("");
            }, 3000);

            return () => clearTimeout(timer); // Limpia el timer si cambia el estado
        }
    }, [success, error]);

    // Limpiar los inpus para facilitar el reingreso de datos  
    const handleLimpiar = () => {
        setIdUsuario("");
        setUsuario("");
        setApaterno("");
        setAmaterno("");
        setCorreo("");
        setIdCargo("");
        setIdDireccion("");
        setIdSede("");
        setIdEdificio("");
        setIdNivel("");
        setIdEstado("");

        setResultados([]);
        setSuccess("");
        setError("");

        setResetEntradaUsuario(true);   // Para limpiar el autocomplete de usuarios
        setTimeout(() => setResetEntradaUsuario(false), 0); // Volver a false para que pueda usarse otra vez
    };

    function validarCampos(filtros, {
        idUsuario,
        usuario,
        aPaterno,
        aMaterno,
        correo,
        idCargo,
        idDireccion,
        idSede,
        idEdificio,
        idNivel,
        idEstado
    }) {
        // Todos los usuarios
        if (filtros.opcTodos) {
            return { valido: true, mensaje: "" };
        }

        // Validar idUsuario
        if (filtros.opcIdUsuario) {
            if (!idUsuario) {
                return { valido: false, mensaje: "Debes ingresar el número de empleado." };
            }
            if (!/^\d{7}$/.test(idUsuario)) {
                return { valido: false, mensaje: "El ID de usuario debe contener exactamente 7 dígitos numéricos." };
            }
        }

        // Validar usuario
        if (filtros.opcUsuario) {
            if (!usuario) {
                return { valido: false, mensaje: "Debes ingresar el nombre(s) del empleado." };
            }
            const nombreRegex = /^[A-Za-zÁÉÍÓÚÑ\s]{1,50}$/;
            if (!nombreRegex.test(usuario)) {
                return { valido: false, mensaje: "El nombre solo puede contener letras y máximo 50 caracteres." };
            }
        }

        // Validar apellido paterno
        if (filtros.opcApaterno) {
            if (!aPaterno) {
                return { valido: false, mensaje: "Debes ingresar el apellido paterno del empleado." };
            }
            const nombreRegex = /^[A-Za-zÁÉÍÓÚÑ\s]{1,50}$/;
            if (!nombreRegex.test(aPaterno)) {
                return { valido: false, mensaje: "El apellido paterno solo puede contener letras y máximo 50 caracteres." };
            }
        }

        // Validar apellido materno
        if (filtros.opcAmaterno) {
            if (!aMaterno) {
                return { valido: false, mensaje: "Debes ingresar el apellido materno del empleado." };
            }
            const nombreRegex = /^[A-Za-zÁÉÍÓÚÑ\s]{1,50}$/;
            if (!nombreRegex.test(aMaterno)) {
                return { valido: false, mensaje: "El apellido materno solo puede contener letras y máximo 50 caracteres." };
            }
        }

        // Validar correo
        if (filtros.opcCorreo) {
            if (!correo) {
                return { valido: false, mensaje: "Debes ingresar el correo del empleado." };
            }
            const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!correoRegex.test(correo) || correo.length > 50) {
                return { valido: false, mensaje: "El correo debe tener formato válido y no exceder 50 caracteres." };
            }
        }

        // Validar cargo
        if (filtros.opcIdCargo && !idCargo) {
            return { valido: false, mensaje: "Debes ingresar un cargo." };
        }

        // Validar dirección
        if (filtros.opcIdDireccion && !idDireccion) {
            return { valido: false, mensaje: "Debes ingresar una Dirección Administrativa." };
        }

        // Validar sede
        if (filtros.opcIdSede && !idSede) {
            return { valido: false, mensaje: "Debes ingresar una sede." };
        }

        // Validar edificio
        if (filtros.opcIdEdificio && !idEdificio) {
            return { valido: false, mensaje: "Debes ingresar un edificio." };
        }

        // Validar nivel
        if (filtros.opcIdNivel && !idNivel) {
            return { valido: false, mensaje: "Debes ingresar un nivel." };
        }

        // Validar estado
        if (filtros.opcIdEstado && !idEstado) {
            return { valido: false, mensaje: "Debes ingresar un estado de usuario." };
        }

        // Si pasa todas las validaciones
        return { valido: true, mensaje: "" };
    }

    // Diccionario de cabeceras para la lista de resultado en PDF //////////////////////////ok
    const diccionarioCabeceras = {
        idUsuario: "Número Empleado",
        usuario: "Nombre",
        aPaterno: "Apellido Paterno",
        aMaterno: "Apellido Materno",
        correo: "Correo",
        idCargo: "Id Cargo",
        idDireccion: "Id Dirección Admin.",
        idSede: "Id Sede",
        idEdificio: "Id Edificio",
        idNivel: "Id Nivel",
        idEstado: "Id Estado"
    };

    // Función para mostrar solo ciertas columnas y no saturar la pantalla con exceso de información //////////////ok
    const columnasVisibles = [
        "idUsuario",
        "usuario",
        "aPaterno",
        "aMaterno",
        "idEstado"
    ];

    // Función para conectar y enviar los datos a la api
    const handleGenerarReporte = async () => {
        const valores = {
            idUsuario,
            usuario,
            aPaterno,
            aMaterno,
            correo,
            idCargo,
            idDireccion,
            idSede,
            idEdificio,
            idNivel,
            idEstado,

            filtroPrincipal
        };

        const resultado = validarCampos(filtros, valores);

        if (!resultado.valido) {
            setError(resultado.mensaje);
            setSuccess("");
            return;
        }

        try {
            const data = await apiFetch("reporte_usuarios.php", {
                method: "POST",
                body: JSON.stringify(valores),
                headers: { "Content-Type": "application/json" }
            }, logout);

            if (data.status === "ok" && data.data.length > 0) {
                setResultados(data.data || []); // Se guardan los resultados
                setSuccess("Reporte generado correctamente.");
                setVistaLocal("resultados");
                setError("");
            } else if (data.status === "no_results") {
                setError("No se encontraron registros que cumplan con los filtros.");
                setSuccess("");
            } else {
                setError("Error al generar reporte: " + (data.message || "Error desconocido."));
                setSuccess("");
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
            setSuccess("");
        }
    };

    // Funcion para exportar en CSV (todas las columnas de la consulta)
    const exportCSV = () => {
        if (!resultados.length) return;

        const columnas = Object.keys(resultados[0]); // Todas las columnas no solo las visibles en PDF
        const filas = resultados.map(fila =>
            columnas.map(col => {
                let valor = fila[col] !== null ? String(fila[col]) : "";
                // Escapar comillas dobles
                valor = valor.replace(/"/g, '""');
                // Encapsular en comillas si contiene coma, salto de línea o comillas para mantener dato y encabezado correctos
                if (/[",\n]/.test(valor)) {
                    valor = `"${valor}"`;
                }
                return valor;
            })
        );

        const csvRows = [];
        csvRows.push(columnas.join(",")); // Encabezados
        filas.forEach(row => csvRows.push(row.join(",")));

        const csvString = csvRows.join("\n");
        const BOM = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reporte_usuarios.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Función para exportar en PDF (solo lo que se muestra en la tabla)
    const exportPDF = () => {
        if (!resultados.length) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de usuarios", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla con columnas visibles
        autoTable(doc, {
            startY: 50,
            head: [columnasVisibles.map(col => diccionarioCabeceras[col] || col)],
            body: resultados.map(fila =>
                columnasVisibles.map(col => fila[col])
            )
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("reporte_usuarios.pdf");
    };

    // Función para regresar de la vista formulario a la vista de seleccion de opciones de filtrado   
    const handleRegresar = () => {
        handleLimpiar();
        setSuccess("");
        setError("");
        setVistaLocal("opcionesUsuarios");
    };

    // Función para regresar al formulario
    const handleRegresarFormulario = () => {
        handleLimpiar();
        setSuccess("");
        setError("");
        setResultados([]);

        if (filtroPrincipal === "opcTodos") {
            // Caso especial: no hay formulario, regresar a opciones
            setVistaLocal("opcionesUsuarios");
        } else {
            // Flujo normal: regresar al formulario
            setVistaLocal("formulario");
        }
    };

    return (
        <div className="sesion-form">
            {vistaLocal === "opcionesUsuarios" && (
                <div>
                    {error && <div className="error">{error}</div>}

                    <div className="filtros-container">
                        {Object.keys(filtros).map((campo) => {
                            const deshabilitado = filtroPrincipal
                                ? reglas[filtroPrincipal]?.deshabilita?.includes(campo)
                                : false;

                            return (
                                <label
                                    key={campo}
                                    className={deshabilitado ? "checkbox-disabled" : "checkbox-enabled"}
                                >
                                    <input
                                        type="checkbox"
                                        checked={filtros[campo]}
                                        onChange={() => handleChange(campo)}
                                        disabled={deshabilitado}
                                    />
                                    {etiquetas[campo]}
                                </label>
                            );
                        })}
                    </div>

                    <div className="form-buttons">
                        <button
                            onClick={() => {
                                const algunFiltroActivo = Object.values(filtros).some(v => v === true);

                                if (!algunFiltroActivo) {
                                    setError("Debes seleccionar al menos un filtro antes de continuar.");
                                    return;
                                }

                                setError(""); // Limpia el error si todo está bien

                                if (filtroPrincipal === "opcTodos") {
                                    // Caso especial: no pasar por formulario
                                    handleGenerarReporte();
                                    setVistaLocal("resultados");
                                } else {
                                    // Flujo normal: ir al formulario
                                    setVistaLocal("formulario");
                                }
                            }}
                        >
                            Continuar
                        </button>

                        <button onClick={() => {
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                        }}>
                            Limpiar
                        </button>

                        <button onClick={() => {
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                            setVista("hardware")
                        }}>
                            Volver
                        </button>
                    </div>
                </div>
            )}

            {vistaLocal === "formulario" && (
                <div>
                    {error && <div className="error">{error}</div>}

                    <h3>Ingrese los datos para generar el reporte</h3>

                    {filtros.opcIdUsuario && (
                        <div>
                            <InputGenerico
                                value={idUsuario}
                                setValue={setIdUsuario}
                                label="Número de empleado"
                                maxLength={7}
                                allowedChars="0-9"
                                placeholder="7120000"
                                title="Debe contener exactamente 7 dígitos numéricos"
                            />
                        </div>
                    )}

                    {filtros.opcUsuario && (
                        <div>
                            <InputGenerico
                                value={usuario}
                                setValue={setUsuario}
                                label="Nombre(s) del empleado"
                                maxLength={50}
                                allowedChars="A-Z ÁÉÍÓÚÑ"
                                transform="uppercase"
                                placeholder="Ingrese el nombre"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcApaterno && (
                        <div>
                            <InputGenerico
                                value={aPaterno}
                                setValue={setApaterno}
                                label="Apellido paterno"
                                maxLength={50}
                                allowedChars="A-Z ÁÉÍÓÚÑ"
                                transform="uppercase"
                                placeholder="Ingrese el apellido paterno"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcAmaterno && (
                        <div>
                            <InputGenerico
                                value={aMaterno}
                                setValue={setAmaterno}
                                label="Apellido materno"
                                maxLength={50}
                                allowedChars="A-Z ÁÉÍÓÚÑ"
                                transform="uppercase"
                                placeholder="Ingrese el apellido materno"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcCorreo && (
                        <div>
                            <InputGenerico
                                type="email"
                                value={correo}
                                setValue={setCorreo}
                                label="Correo electrónico"
                                maxLength={50}
                                allowedChars="A-Za-z0-9@._-"
                                transform="lowercase"
                                placeholder="ejemplo@dominio.com"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcIdCargo && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idCargo}
                                setIdSeleccionado={setIdCargo}
                                label="Cargo"
                                apiUrl={`consultar_cargos.php`}
                                valueField="id_cargo"
                                displayField="cargo"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione un cargo"
                            />
                        </div>
                    )}

                    {filtros.opcIdDireccion && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idDireccion}
                                setIdSeleccionado={setIdDireccion}
                                label="Dirección Administrativa"
                                apiUrl={`consultar_direcciones.php`}
                                valueField="id_direccion"
                                displayField="direccion_a"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione Dirección Administrativa"
                            />
                        </div>
                    )}

                    {filtros.opcIdSede && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idSede}
                                setIdSeleccionado={setIdSede}
                                label="Sede"
                                apiUrl={`consultar_sedes.php`}
                                valueField="id_sede"
                                displayField="acronimo"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione una sede"
                            />
                        </div>
                    )}

                    {filtros.opcIdEdificio && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idEdificio}
                                setIdSeleccionado={setIdEdificio}
                                label="Edificio"
                                apiUrl={`consultar_edificios.php`}
                                valueField="id_edificio"
                                displayField="edificio"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione un edificio"
                            />
                        </div>
                    )}

                    {filtros.opcIdNivel && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idNivel}
                                setIdSeleccionado={setIdNivel}
                                label="Nivel"
                                apiUrl={`consultar_niveles.php`}
                                valueField="id_nivel"
                                displayField="nivel"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione un piso o nivel"
                            />
                        </div>
                    )}

                    {filtros.opcIdEstado && (
                        <div>
                            <InputSelectEstados
                                idEstado={idEstado}
                                setIdEstado={setIdEstado}
                                estadoActualText=""
                                idEntidad={3}
                                label="Estado del bien"
                                mostrar="todos" // Se pasa la prop "mostrar" con valor "todos" para que muestre todos los estados de la entidad y no realice los filtros de eliminados
                            />
                        </div>
                    )}

                    <div className="form-buttons">
                        <button onClick={handleGenerarReporte}>
                            Generar<br />reporte
                        </button>
                        <button onClick={handleLimpiar}>
                            Limpiar<br />datos
                        </button>
                        <button onClick={handleRegresar}>
                            Regresar
                        </button>

                    </div>

                </div>
            )}

            {vistaLocal === "resultados" && (
                <div>
                    <h3>Resultados de usuarios</h3>

                    {resultados.length > 0 && (
                        <>
                            <table className="tabla-estandar">
                                <thead>
                                    <tr>
                                        {columnasVisibles.map((col) => (
                                            <th key={col}>{diccionarioCabeceras[col] || col}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {resultados.map((fila, idx) => (
                                        <tr key={idx}>
                                            {columnasVisibles.map((col) => (
                                                <td key={col} data-label={diccionarioCabeceras[col] || col}>
                                                    {fila[col]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="form-buttons">
                                <button onClick={handleRegresarFormulario}>Regresar</button>
                                <button onClick={exportCSV}>Exportar<br></br>en CSV</button>
                                <button onClick={exportPDF}>Exportar<br></br>en PDF</button>
                            </div>
                        </>
                    )}

                </div>
            )}

        </div>
    );
}

export default ReporteUsuarios;